import type { LucideIcon } from 'lucide-react';
import type { ComponentPropsWithoutRef, Ref } from 'react';
import { cx } from '../../utils/cx';
import { Icon } from '../Icon/Icon';
import s from './Fab.module.css';

export type FabProps = Omit<ComponentPropsWithoutRef<'button'>, 'children'> & {
  ref?: Ref<HTMLButtonElement>;
  icon: LucideIcon;
  /** Accessible name; also shown as text when `extended`. */
  label: string;
  extended?: boolean;
  /** Sits above the bottom nav (default) or at the screen bottom. */
  placement?: 'aboveNav' | 'bottom';
};

/** The floating "+" action, in thumb reach on phones. Hidden from lg up (the sidebar has the action). */
export function Fab({
  icon,
  label,
  extended,
  placement = 'aboveNav',
  className,
  type,
  ...rest
}: FabProps) {
  return (
    <button
      type={type ?? 'button'}
      className={cx(s.fab, className)}
      data-extended={extended || undefined}
      data-placement={placement}
      aria-label={extended ? undefined : label}
      {...rest}
    >
      <Icon icon={icon} size="lg" />
      {extended ? <span>{label}</span> : null}
    </button>
  );
}
